webpackJsonp([274],{

/***/ 1333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiskUserTable_vue__ = __webpack_require__(3107);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1836722a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskUserTable_vue__ = __webpack_require__(5853);
function injectStyle (ssrContext) {
  __webpack_require__(5851)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1836722a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiskUserTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1836722a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskUserTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 2505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    isRiskStatus: function isRiskStatus(row) {
      return Number(row.risk_status) === 1;
    },
    isHighInvalidPercent: function isHighInvalidPercent(row) {
      return row.total_invalid_percent >= 70;
    },
    isCustomerRisk: function isCustomerRisk(row) {
      return row && row.order_percent >= 80;
    }
  }
});

/***/ }),

/***/ 3107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_users_user_risk_mixins__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__ = __webpack_require__(1347);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__views_users_user_risk_mixins__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    riskusersOpts: function riskusersOpts(state) {
      return state.users.riskusersOpts;
    }
  })),
  created: function created() {
    var _this = this;

    this.getChinaAreaData();
    this.$nextTick(function () {
      return _this.loadStats();
    }); // 使用$nextTick避免搜索参数未生成
  },
  data: function data() {
    var _this2 = this;

    return {
      search: {
        userid: null,
        customerid: null,
        cellphone: null,
        has_customer_risk: null,
        has_invalid_risk: null,
        risk_status: null,
        confirm_status: null,
        confirmed_adminuserid: null,
        became_risk_at: [],
        regionids: []
      },
      searchFieldType: {
        order_percent: Array,
        total_invalid_percent: Array,
        became_risk_at: Array
      },
      chinaAreaData: [],
      fields: [{ prop: 'userid', label: '零工ID', width: 80 }, { prop: 'realname', label: '姓名', width: 80 }, { prop: 'province_name', label: '省份' }, { prop: 'city_name', label: '城市' }, { prop: 'area_name', label: '地区' }, { prop: 'total_pass_order_count', label: '累计完单数', tooltip: '近期一年数据' }, {
        prop: 'customer_stats__formatted',
        label: '单一客户完单率',
        width: 180,
        tooltip: '大于等于值80%',
        class: function _class(attr, row) {
          return { 'is-risk': _this2.isRiskClass(attr.prop, row) };
        },
        formatter: function formatter(row) {
          return row.customer_stats.length > 0 ? _this2.joinCustomer(row.customer_stats) : '';
        }
      }, {
        prop: 'total_invalid_percent__formatted',
        label: '工单失效率',
        tooltip: '大于等于值70%',
        class: function _class(attr, row) {
          return { 'is-risk': _this2.isRiskClass(attr.prop, row) };
        },
        formatter: function formatter(row) {
          return row.total_invalid_percent ? row.total_invalid_percent + '%' : '';
        }
      }, {
        prop: 'risk_status__formatted',
        label: '风险状态',
        width: 90,
        class: function _class(attr, row) {
          return { 'is-risk': _this2.isRiskClass(attr.prop, row) };
        },
        formatter: function formatter(row) {
          return _this2.riskusersOpts.riskStatusOpts[row.risk_status];
        }
      }, {
        prop: 'confirm_status__formatted',
        label: '确认状态',
        width: 90,
        formatter: function formatter(row) {
          return _this2.riskusersOpts.riskConfirmStatusOpts[row.confirm_status];
        }
      }, {
        prop: 'confirmed_adminusername__formatted',
        label: '负责人',
        formatter: function formatter(row) {
          return row.confirmed_adminuserid ? row.confirmed_adminusername + ' / ' + row.confirmed_adminuserid : '';
        }
      }, { prop: 'confirmed_at', label: '确认时间' }, { prop: 'became_risk_at', label: '触发风险时间' }, { prop: 'last_active_tp', label: '最后登录时间', width: 160 }],
      stats: {
        total_user_cnt: 0,
        customer_risk_user_cnt: 0,
        invalid_risk_user_cnt: 0,
        high_risk_percent: 0
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getTableData: function getTableData(params) {
      return request.page('queryRiskUsers', params);
    },
    loadStats: function loadStats(params) {
      var _this3 = this;

      params = Object(__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["b" /* removeEmptyParams */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.lastSearchParams, params));

      return request.page('getRiskUserStats', params).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this3.stats, data);
      }).catch(function () {});
    },
    onTableSearch: function onTableSearch(params) {
      this.onSearch(params);
      this.loadStats(params);
    },
    isHighOrderPercent: function isHighOrderPercent(row) {
      return row.customer_stats.length > 0 && this.isCustomerRisk(row.customer_stats[0]);
    },
    isRiskClass: function isRiskClass(key, row) {
      if (key === 'customer_stats__formatted' && this.isHighOrderPercent(row)) {
        return true;
      }
      if (key === 'total_invalid_percent__formatted' && this.isHighInvalidPercent(row)) {
        return true;
      }
      if (key === 'risk_status__formatted' && this.isRiskStatus(row)) {
        return true;
      }
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title + '_\u641C\u7D22\u7ED3\u679C', {
        fileHeader: this.fields.map(function (item) {
          return {
            key: item.prop,
            text: item.label,
            formatter: item.formatter
          };
        }),
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["b" /* removeEmptyParams */])(_.cloneDeep(this.search))
      });
    },
    getChinaAreaData: function getChinaAreaData() {
      var _this4 = this;

      request.alert('queryAllFormatted').then(function (_ref2) {
        var data = _ref2.data;

        _this4.chinaAreaData = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
      }).catch(function () {
        _this4.chinaAreaData = [];
      });
    },
    joinCustomer: function joinCustomer(customers) {
      return customers.map(function (it) {
        return it.customername + ' ' + it.order_percent + '%';
      }).join('\n');
    },
    htmlRow: function htmlRow(text) {
      if (text === null || text === undefined) {
        return '';
      }
      return String(text).replace(/\n/g, '<br>');
    }
  })
});

/***/ }),

/***/ 5851:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5852);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("08e089ed", content, true, {});

/***/ }),

/***/ 5852:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".risk-user-stat-card[data-v-1836722a]{border:1px solid #ebeef5;border-radius:4px;padding:16px 20px;background:#fff}.risk-user-stat-card__label[data-v-1836722a]{font-size:14px;color:#909399;margin-bottom:8px}.risk-user-stat-card__value[data-v-1836722a]{font-size:28px;font-weight:600;color:#303133;line-height:1.2}.is-risk[data-v-1836722a]{color:#f56c6c!important}", "", {"version":3,"sources":["/workspace/src/views/users/pages/RiskUserTable.vue"],"names":[],"mappings":"AACA,sCAAsC,yBAAyB,kBAAkB,kBAAkB,eAAe,CACjH,AACD,6CAA6C,eAAe,cAAc,iBAAiB,CAC1F,AACD,6CAA6C,eAAe,gBAAgB,cAAc,eAAe,CACxG,AACD,0BAA0B,uBAAwB,CACjD","file":"RiskUserTable.vue","sourcesContent":["\n.risk-user-stat-card[data-v-1836722a]{border:1px solid #ebeef5;border-radius:4px;padding:16px 20px;background:#fff\n}\n.risk-user-stat-card__label[data-v-1836722a]{font-size:14px;color:#909399;margin-bottom:8px\n}\n.risk-user-stat-card__value[data-v-1836722a]{font-size:28px;font-weight:600;color:#303133;line-height:1.2\n}\n.is-risk[data-v-1836722a]{color:#f56c6c !important\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("搜索")]},proxy:true}])},[_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"120px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onTableSearch($event)}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"零工ID","prop":"userid"}},[_c('el-input',{attrs:{"placeholder":"请输入零工ID","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户","prop":"customerid"}},[_c('remote-select',{attrs:{"placeholder":"请输入客户名称/编号搜索","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail,"clearable":""},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"零工手机号","prop":"cellphone"}},[_c('el-input',{attrs:{"placeholder":"请输入零工手机号","clearable":""},model:{value:(_vm.search.cellphone),callback:function ($$v) {_vm.$set(_vm.search, "cellphone", $$v)},expression:"search.cellphone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户完单风险","prop":"has_customer_risk"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.has_customer_risk),callback:function ($$v) {_vm.$set(_vm.search, "has_customer_risk", $$v)},expression:"search.has_customer_risk"}},_vm._l(({1: '是', 2: '否'}),function(label,key){return _c('el-option',{key:key,attrs:{"label":label,"value":key}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单失效风险","prop":"has_invalid_risk"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.has_invalid_risk),callback:function ($$v) {_vm.$set(_vm.search, "has_invalid_risk", $$v)},expression:"search.has_invalid_risk"}},_vm._l(({1: '是', 2: '否'}),function(label,key){return _c('el-option',{key:key,attrs:{"label":label,"value":key}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"风险状态","prop":"risk_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.risk_status),callback:function ($$v) {_vm.$set(_vm.search, "risk_status", $$v)},expression:"search.risk_status"}},_vm._l((_vm.riskusersOpts.riskStatusOpts),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"确认状态","prop":"confirm_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.confirm_status),callback:function ($$v) {_vm.$set(_vm.search, "confirm_status", $$v)},expression:"search.confirm_status"}},_vm._l((_vm.riskusersOpts.riskConfirmStatusOpts),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"regionids"}},[_c('el-cascader',{staticClass:"width-max",attrs:{"options":_vm.chinaAreaData,"props":{ multiple: true, checkStrictly: true },"filterable":"","clearable":""},model:{value:(_vm.search.regionids),callback:function ($$v) {_vm.$set(_vm.search, "regionids", $$v)},expression:"search.regionids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"负责人","prop":"confirmed_adminuserid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请输入管理员","keyword-key":"name","query-request":_vm.getBasicPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.confirmed_adminuserid),callback:function ($$v) {_vm.$set(_vm.search, "confirmed_adminuserid", $$v)},expression:"search.confirmed_adminuserid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"触发风险时间","prop":"became_risk_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.became_risk_at),callback:function ($$v) {_vm.$set(_vm.search, "became_risk_at", $$v)},expression:"search.became_risk_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"risk-user-stat-card"},[_c('div',{staticClass:"risk-user-stat-card__label"},[_vm._v("总零工数")]),_vm._v(" "),_c('div',{staticClass:"risk-user-stat-card__value"},[_vm._v(_vm._s(_vm._f("seperateThousands")(_vm.stats.total_user_cnt)))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"risk-user-stat-card"},[_c('div',{staticClass:"risk-user-stat-card__label"},[_vm._v("单一客户完单风险用户数")]),_vm._v(" "),_c('div',{staticClass:"risk-user-stat-card__value"},[_vm._v(_vm._s(_vm._f("seperateThousands")(_vm.stats.customer_risk_user_cnt)))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"risk-user-stat-card"},[_c('div',{staticClass:"risk-user-stat-card__label"},[_vm._v("工单失效用户数")]),_vm._v(" "),_c('div',{staticClass:"risk-user-stat-card__value"},[_vm._v(_vm._s(_vm._f("seperateThousands")(_vm.stats.invalid_risk_user_cnt)))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"risk-user-stat-card"},[_c('div',{staticClass:"risk-user-stat-card__label"},[_vm._v("高风险用户占比")]),_vm._v(" "),_c('div',{staticClass:"risk-user-stat-card__value"},[_vm._v(_vm._s(_vm.stats.high_risk_percent)+"%")])])])],1)],1),_vm._v(" "),_c('layout-panel',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("列表")]},proxy:true},{key:"tools",fn:function(){return [_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})]},proxy:true}])},[_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"type":"success","icon":"sj-icon-export","size":"small"},on:{"click":_vm.onExportSearch}},[_vm._v("按搜索结果导出\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.fields),function(attr){return [_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',[_vm._v(_vm._s(attr.label))]),_vm._v(" "),(attr.tooltip)?_c('el-tooltip',{attrs:{"content":attr.tooltip}},[_c('i',{staticClass:"el-icon-warning"})]):_vm._e()]},proxy:true},{key:"default",fn:function(scope){return [_c('div',{class:attr.class ? attr.class(attr, scope.row) : null,domProps:{"innerHTML":_vm._s(_vm.htmlRow(attr.formatter ? attr.formatter(scope.row) : scope.row[attr.prop]))}})]}}],null,true)},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"140","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{staticStyle:{"display":"inline-block","padding":"0 5px"},attrs:{"type":"primary","underline":false,"href":("/users/riskusers/detail/" + (scope.row.userid))}},[_vm._v(" 跟进\n          ")]),_vm._v(" "),_c('el-link',{staticStyle:{"display":"inline-block","padding":"0 5px"},attrs:{"type":"primary","underline":false,"href":("/order/table?userid=" + (scope.row.userid))}},[_vm._v(" 工单列表\n          ")])]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-riskusers.d0a738540b9af5d18a0b.js